import React from 'react'
import RatinigClient from '../RatinigClient';
import "animate.css/animate.min.css";
import ScrollAnimation from 'react-animate-on-scroll';
import { Link } from 'react-router-dom';
import { TeacherIcons, TeacherInfo, TeacherItem } from './Style';

export default function Teacher(props) {
  return (
    <ScrollAnimation animateIn="animate__fadeIn">
      <TeacherItem>
        <img src={props.image} />
        <TeacherInfo>
          <Link to='/singleTeacher' href="#">{props.name}</Link>
          <p>Professor</p>
          <RatinigClient />
          <TeacherIcons>
            <span> <i className="fab fa-facebook-f"></i> </span>
            <span> <i className="fab fa-twitter"></i> </span>
            <span> <i className="fab fa-linkedin-in"></i> </span>
            <span> <i className="fab fa-youtube"></i>  </span>
          </TeacherIcons>
        </TeacherInfo>
      </TeacherItem>
    </ScrollAnimation>
  )
}
